import {
  OrganizationInformation,
  OrganizationMembers,
  OrganizationIndividuals,
  OrganizationServices,
  OrganizationNotifications
} from '@/components/Organization'

import type { TabType } from './types'

const organizationTabs: TabType[] = [
  {
    url: 'info',
    label: 'Information',
    component: OrganizationInformation
  },
  {
    url: 'members',
    label: 'Members',
    component: OrganizationMembers
  },
  {
    url: 'individuals',
    label: 'Individuals',
    component: OrganizationIndividuals
  },
  {
    url: 'services',
    label: 'Services',
    component: OrganizationServices,
  },
  {
    url: 'notifications',
    label: 'Notifications',
    component: OrganizationNotifications,
  }
]

export default organizationTabs
